<template>
  <div class="bc_cont">
    <!-- 字段条件选项 -->
    <el-select
      key="fieldNameSelect"
      style="width: 120px"
      size="small"
      class="spacing_right"
      popper-class="condition_popper_select"
      placeholder="请选择"
      v-model="rule.fieldName"
      clearable
      @change="changeFieldNameHandle"
    >
      <el-option v-for="fl of optionList" :key="fl.optionField" :label="fl.optionName" :value="fl.optionField">{{
        fl.optionName
      }}</el-option>
    </el-select>
    <!-- 省市区地址选项 -->
    <el-select
      key="addressTypesSelect"
      style="width: 120px"
      size="small"
      class="spacing_right"
      popper-class="condition_popper_select"
      placeholder="请选择"
      v-model="cascadeIdx"
      v-if="addressField"
      clearable
      @change="changeCascadeIdxHandle"
    >
      <el-option v-for="at of addressTypes" :key="at.value" :label="at.label" :value="at.value">{{ at.label }}</el-option>
    </el-select>
    <!-- 条件符选项 -->
    <el-select
      key="operatorSelect"
      style="width: 120px"
      size="small"
      class="spacing_right"
      popper-class="condition_popper_select"
      placeholder="请选择"
      v-model="rule.type"
      clearable
      @change="changeTypeHandle"
    >
      <el-option v-for="op of operatorOptionList" :key="op.value" :label="op.label" :value="op.value">{{ op.label }}</el-option>
    </el-select>
    <!-- 根据类型 展示不同的控件 -->
    <template v-if="rule.type !== ''">
      <el-input
        style="width: 200px"
        size="small"
        placeholder="请输入"
        v-model="paramsValue"
        v-if="paramType === 'input'"
        clearable
      />
      <el-select
        style="width: 200px"
        size="small"
        placeholder="请选择"
        popper-class="condition_popper_select"
        v-model="paramsValue"
        :multiple="paramType === 'multiSelect'"
        :collapse-tags="paramType === 'multiSelect'"
        v-else-if="paramType === 'select' || paramType === 'multiSelect'"
        clearable
      >
        <el-option
          v-for="(item, index) of currentValue.optionValue || []"
          :key="`co_${index}`"
          :label="item.label"
          :value="item.value"
          >{{ item.label }}</el-option
        >
      </el-select>
      <el-cascader
        style="width: 200px"
        size="small"
        placeholder="请选择"
        :props="{ multiple: true }"
        :collapse-tags="true"
        :options="citydata"
        :disabled="addressField && cascadeIdx === ''"
        v-model="paramsValue"
        v-else-if="paramType === 'cascader'"
        clearable
      />
      <el-date-picker
        style="width: 200px"
        key="date"
        type="date"
        size="small"
        placeholder="请选择"
        value-format="yyyy-MM-dd"
        v-model="paramsValue"
        v-else-if="paramType === 'sgDate'"
        clearable
      />
      <el-date-picker
        style="width: 200px"
        key="dateRange"
        type="daterange"
        size="small"
        placeholder="请选择"
        value-format="yyyy-MM-dd"
        v-model="paramsValue"
        v-else-if="paramType === 'dbDate'"
        clearable
      />
      <el-input-number
        style="width: 100px"
        size="small"
        placeholder="请输入"
        controls-position="right"
        v-model="paramsValue"
        v-else-if="paramType === 'sgNumber'"
      />
      <input-number-range v-model="paramsValue" v-else-if="paramType === 'dbNumber'" />
    </template>
  </div>
</template>

<script>
import citydata from '@/assets/js/config/citydata'
import { setCascaderLevel } from '@/assets/js/utils'
// import { getSampleOptions } from '@/api/common';
import { getInvestigatorOptions } from '@/api/more-app/investigator-base'
import { handleList } from './options'

import { inputRulers, selectRulers, multiSelectRulers, cascaderRulers, numberRulers, dateRulers, addressTypes } from './config'
import { COMMON, INPUT, SELECT, MULTI_SELECT, CASCADER, NUMBER, DATE, ADDRESS_TYPES } from './constants'
import InputNumberRange from './InputNumberRange'

export default {
  name: 'BaseCondition',
  components: {
    InputNumberRange
  },
  props: {
    isOptionsLoad: {
      type: Boolean,
      default: false
    },
    rule: {
      type: Object,
      default: () => ({})
    },
    classifyType: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      operatorMap: {
        input: inputRulers,
        select: selectRulers,
        date: dateRulers,
        cascader: cascaderRulers,
        number: numberRulers,
        multiSelect: multiSelectRulers,
        address: addressTypes
      },
      addressTypes,
      citydata,
      baseInfoList: [],
      fieldList: []
    }
  },
  inject: {
    conditionInject: {
      default: () => ({
        baseInfoOptions: [],
        investigatorOptions: []
      })
    }
  },
  computed: {
    optionList() {
      switch (`${this.classifyType}`) {
        case '0':
          return this.baseInfoOptionList
        case '1':
          console.log('this.fieldOptionList',this.fieldOptionList)
          return this.fieldOptionList
        case '2':
          return []
        default:
          return []
      }
    },
    currentValue() {
      switch (`${this.classifyType}`) {
        case '0':
          return this.baseInfoValue
        case '1':
          return this.fieldValue
        case '2':
          return {}
        default:
          return {}
      }
    },
    fieldOptionList() {
      return this.isOptionsLoad ? this.fieldList : this.conditionInject.investigatorOptions
    },
    baseInfoOptionList() {
      return this.isOptionsLoad ? this.baseInfoList : this.conditionInject.baseInfoOptions
    },
    fieldValue() {
      return this.fieldOptionList.find(f => f.optionField === this.rule.fieldName) || {}
    },
    baseInfoValue() {
      return this.baseInfoOptionList.find(f => f.optionField === this.rule.fieldName) || {}
    },
    operatorOptionList() {
      if (this.addressField && this.rule.cascadeIdx == ADDRESS_TYPES.DETAILED_ADDRESS) {
        return this.operatorMap.input
      }
      const { optionType } = this.currentValue
      return optionType ? this.operatorMap[optionType] || [] : []
    },
    addressField() {
      return ['currentLocation', 'local'].includes(this.rule.fieldName)
    },
    localAddressType() {
      if (this.addressField) {
        const hide = Object.values(COMMON).includes(this.rule.type)
        if (this.rule.cascadeIdx == ADDRESS_TYPES.DETAILED_ADDRESS) {
          return hide ? null : 'input'
        } else {
          return hide ? null : 'cascader'
        }
      }
      return null
    },
    paramType() {
      const { optionType } = this.currentValue
      switch (optionType) {
        case 'input': {
          const existType = Object.values(INPUT).includes(this.rule.type)
          return existType ? 'input' : null
        }
        case 'select': {
          const existType = Object.values(SELECT).includes(this.rule.type)
          return existType ? 'multiSelect' : null
        }
        case 'multiSelect': {
          const existType = Object.values(MULTI_SELECT).includes(this.rule.type)
          return existType ? 'multiSelect' : null
        }
        case 'number': {
          const sgNums = Object.values(NUMBER).filter(f => f !== NUMBER.BETWEEN && f !== NUMBER.NOT_BETWEEN)
          const dbNums = [NUMBER.BETWEEN, NUMBER.NOT_BETWEEN]
          const existTypeSG = sgNums.includes(this.rule.type)
          const existTypeDB = dbNums.includes(this.rule.type)
          if (existTypeSG) {
            return 'sgNumber'
          } else if (existTypeDB) {
            return 'dbNumber'
          }
          return null
        }
        case 'date': {
          const sgDates = Object.values(DATE).filter(f => f !== DATE.BETWEEN && f !== DATE.NOT_BETWEEN)
          const dbDates = [DATE.BETWEEN, DATE.NOT_BETWEEN]
          const existTypeSG = sgDates.includes(this.rule.type)
          const existTypeDB = dbDates.includes(this.rule.type)
          if (existTypeSG) {
            return 'sgDate'
          } else if (existTypeDB) {
            return 'dbDate'
          }
          return null
        }
        case 'address':
        case 'cascader': {
          if (this.localAddressType !== null) return this.localAddressType
          const existType = Object.values(CASCADER).includes(this.rule.type)
          return existType ? 'cascader' : null
        }
        default:
          return null
      }
    },
    cascadeIdx: {
      get() {
        return this.rule.cascadeIdx == 0 ? '' : +this.rule.cascadeIdx ?? ''
      },
      set(val) {
        this.rule.cascadeIdx = val === '' ? 0 : Number.isNaN(+val) ? 0 : +val
      }
    },
    paramsValue: {
      get() {
        switch (true) {
          case this.rule.params === null:
            return null
          case this.paramType === 'cascader':
            return this.rule.params.map(str => str.split('/'))
          case ['input', 'sgNumber', 'sgDate'].includes(this.paramType):
            return this.rule.params?.[0] ?? null
          case Array.isArray(this.rule.params):
            return this.rule.params
          default:
            return null
        }
      },
      set(val) {
        if (val === null) {
          this.rule.params = null
        } else if (this.paramType === 'cascader') {
          this.rule.params = val.map(arr => arr.join('/'))
        } else if (Array.isArray(val)) {
          this.rule.params = val
        } else {
          this.rule.params = [val]
        }
      }
    }
  },
  watch: {
    classifyType() {
      this.resetValue()
    }
  },
  mounted() {
    if (this.isOptionsLoad) {
      this.getFieldList()
    } else {
      this.rule.attributeId = this.currentValue.optionId ?? -1
    }
    this.setCascaderOptions()
  },
  beforeDestroy() {
    this.resetValue()
  },
  methods: {
    getFieldList() {
      getInvestigatorOptions({ classify: '0' })
        .then(res => {
          const list = res.data?.data || []
          this.baseInfoList = handleList(list)
          if (this.classifyType == 0) {
            this.rule.attributeId = list[0]?.optionId ?? -1
          }
        })
        .catch(() => {
          this.$message.error('获取基础信息选项失败')
        })
      getInvestigatorOptions({ classify: '1' })
        .then(res => {
          const list = res.data?.data || []
          this.fieldList = handleList(list)
          if (this.classifyType == 1) {
            this.rule.attributeId = list[0]?.optionId ?? -1
          }
        })
        .catch(() => {
          this.$message.error('获取调查员属性选项失败')
        })
    },
    setCascaderOptions() {
      const isCascaderLevel = Object.values(ADDRESS_TYPES).includes(+this.rule.cascadeIdx)
      if (isCascaderLevel && this.rule.cascadeIdx != ADDRESS_TYPES.DETAILED_ADDRESS) {
        this.citydata = setCascaderLevel(1, citydata, this.rule.cascadeIdx)
      } else {
        this.citydata = citydata
      }
    },
    changeFieldNameHandle() {
      if (this.addressField) {
        this.rule.cascadeIdx = 0
        this.rule.type = ''
      } else {
        this.rule.type = this.operatorOptionList[0]?.value || ''
      }
      this.paramsValue = null
      this.rule.attributeId = this.currentValue.optionId ?? -1
    },
    changeCascadeIdxHandle() {
      this.rule.type = ''
      this.paramsValue = null
      this.setCascaderOptions()
    },
    changeTypeHandle() {
      const isEQNull = Object.values(COMMON).includes(this.rule.type)
      const sdSwitch = ['sgDate', 'dbDate', 'sgNumber', 'dbNumber'].includes(this.paramType)
      if (isEQNull || this.rule.type === '' || sdSwitch) {
        this.paramsValue = null
      }
    },
    resetValue() {
      this.rule.attributeId = -1
      this.rule.fieldName = ''
      this.rule.cascadeIdx = 0
      this.rule.type = ''
      this.paramsValue = null
    }
  }
}
</script>

<style lang="scss" scoped>
.bc_cont {
  display: flex;
  align-items: center;
  .spacing_right {
    margin-right: 8px;
  }
  ::v-deep .el-select__tags {
    & > span {
      display: flex;
    }
    .el-tag {
      display: flex;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
      .el-select__tags-text {
        max-width: 90px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .el-tag__close {
        margin-top: 1px;
        margin-right: 5px;
      }
    }
  }
}
</style>
